import { render, staticRenderFns } from "./Contribute.vue?vue&type=template&id=2f5d8f83&"
import script from "./Contribute.vue?vue&type=script&lang=js&"
export * from "./Contribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports